import { Users, Award, Home, Calendar } from 'lucide-react';
import { useIntersectionObserver } from '../hooks/useIntersectionObserver';
import StatCard from './Stats/StatCard';

const Stats = () => {
  const { ref: statsRef, isVisible } = useIntersectionObserver(0.3);

  const stats = [
    {
      id: 'windows',
      icon: <Home size={40} />,
      value: 2000,
      suffix: '+',
      label: 'Fenêtres Nettoyées'
    },
    {
      id: 'experience',
      icon: <Calendar size={40} />,
      value: 20,
      suffix: ' Ans',
      label: "D'Expérience"
    },
    {
      id: 'clients',
      icon: <Users size={40} />,
      value: 500,
      suffix: '+',
      label: 'Clients Satisfaits'
    },
    {
      id: 'satisfaction',
      icon: <Award size={40} />,
      value: 100,
      suffix: '%',
      label: 'Satisfaction Garantie'
    }
  ];

  return (
    <section ref={statsRef} className="stats-section">
      <div className="container">
        <div className="stats-grid">
          {stats.map((stat) => (
            <StatCard key={stat.id} stat={stat} isVisible={isVisible} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
